// extracted by mini-css-extract-plugin
export default {"thumbnail":"Thumbnail_thumbnail__-7Due"};